var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { UPDATE_ADDRESS_STATUS_REQUEST, updateAddressStatusFailure, updateAddressStatusSuccess } from '../../actions';
import API from '../../../utils/API';
const onUpdateAddressStatus = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const addressId = action.payload.addressId;
            const category = action.payload.category;
            const status = action.payload.status;
            API.put(`onbd/company/address/${addressId}/category/${category}?action=${status}`, {})
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* updateAddressStatusWorker(action) {
    try {
        const data = yield call(onUpdateAddressStatus, action);
        yield put(updateAddressStatusSuccess(data));
    }
    catch (error) {
        yield put(updateAddressStatusFailure(error));
    }
}
export function* watchUpdateAddressStatusData() {
    yield takeLatest(UPDATE_ADDRESS_STATUS_REQUEST, updateAddressStatusWorker);
}
